export default "__VITE_ASSET__BLfI9wAW__"